<template>
  <button class="button-google">
    <FontAwesomeIcon :icon="['fab', 'google']" />
    Sign in with Google
  </button>
</template>

<script>
export default {
  name: 'ButtonGoogleSignIn'
}
</script>

<style lang="scss" scoped>
.button-google {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border: 0;
    border-radius: 5px;
    outline: 0;
    transition: all 0.1s;
    background: rgba(#000, 0.2);
    color: map-get($color-util, 'light');
    font-weight: 700;

    &:hover,
    &:focus {
      transform: scale(1.1);
      background: rgba(#000, 0.4);
    }

    svg {
      margin-right: 10px;
      font-size: 20px;
    }
}
</style>
